module.exports = __webpack_public_path__ + "img/zhxy_image_2.ce6f087b.png";